import { useEffect, useRef } from "react";
import type { Editor } from "@tiptap/react";

/** `onCloseAutoFocus` for a text-toolbar dropdown: put the caret back in the
 *  text, where it was, instead of on the dropdown's trigger. */
export const refocusEditor = (editor: Editor) => (e: Event) => {
    e.preventDefault();
    if (!editor.isDestroyed) editor.commands.focus();
};

/** The same for a non-modal popover. A click elsewhere closes it, and a click
 *  that removes the toolbar unmounts it: either way focus stays where the
 *  user went. */
export function usePopoverRefocus(editor: Editor) {
    const outsideRef = useRef(false);
    const mountedRef = useRef(true);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return {
        onInteractOutside: () => {
            outsideRef.current = true;
        },
        onCloseAutoFocus: (e: Event) => {
            if (outsideRef.current || !mountedRef.current)
                outsideRef.current = false;
            else refocusEditor(editor)(e);
        },
    };
}
